// Tourance — light interaction layer + cart drawer (Section Rendering API)
(function () {
  'use strict';

  function $(s, root) { return (root || document).querySelector(s); }
  function $$(s, root) { return Array.from((root || document).querySelectorAll(s)); }

  // ---------- Drawer open/close ----------
  var drawer  = $('.cart-drawer');
  var overlay = $('.cart-overlay');
  var menuDrawer  = $('.menu-drawer');
  var menuOverlay = $('.menu-overlay');

  function openCart() {
    closeMenu();
    if (drawer)  drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (!isMenuOpen()) document.body.style.overflow = '';
  }
  function isMenuOpen() { return menuDrawer && menuDrawer.classList.contains('is-open'); }
  function openMenu() {
    closeCart();
    if (menuDrawer)  menuDrawer.classList.add('is-open');
    if (menuOverlay) menuOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (menuDrawer)  menuDrawer.classList.remove('is-open');
    if (menuOverlay) menuOverlay.classList.remove('is-open');
    if (drawer && !drawer.classList.contains('is-open')) document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    var openC = e.target.closest('[data-open-cart]');
    if (openC) { e.preventDefault(); openCart(); return; }
    var closeC = e.target.closest('[data-close-cart]');
    if (closeC) { e.preventDefault(); closeCart(); return; }
    var openM = e.target.closest('[data-open-menu]');
    if (openM) { e.preventDefault(); openMenu(); return; }
    var closeM = e.target.closest('[data-close-menu]');
    if (closeM) { e.preventDefault(); closeMenu(); return; }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  // ---------- Sticky header elevation ----------
  var headerEl = $('.header');
  function handleScroll() {
    var y = window.scrollY;
    if (y > 30) {
      document.documentElement.classList.add('is-scrolled');
      if (headerEl) headerEl.classList.add('header--scrolled');
    } else {
      document.documentElement.classList.remove('is-scrolled');
      if (headerEl) headerEl.classList.remove('header--scrolled');
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // ---------- Cart helpers ----------
  var ROUTES = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART = ROUTES.replace(/\/$/, '') + '/cart';
  var SECTION_ID = 'cart-drawer';

  function withBusy(fn) {
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    var p;
    try { p = Promise.resolve(fn()); }
    catch (e) { p = Promise.reject(e); }
    return p.finally(function(){ if (drawer) drawer.removeAttribute('aria-busy'); });
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(function(el){ el.textContent = count; });
  }

  /*
   * Re-render the drawer from the server via Section Rendering API.
   * GET /?sections=<section-id> returns { '<section-id>': '<html>' }.
   * We swap the inner #shopify-section-cart-drawer element so the outer
   * <aside> (and its is-open state) is preserved.
   */
  function rerenderDrawer() {
    return fetch(ROUTES + '?sections=' + SECTION_ID, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data) return;
        var html = data[SECTION_ID] || data['cart-drawer'];
        if (!html) return;
        // The response is the section markup wrapped in <div id="shopify-section-cart-drawer">
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newSection = temp.querySelector('#shopify-section-cart-drawer');
        var target = document.getElementById('shopify-section-cart-drawer');
        if (newSection && target) {
          target.replaceWith(newSection);
        } else if (html) {
          // Fallback: replace inside the <aside>
          var asideEl = document.getElementById('CartDrawer');
          if (asideEl) {
            // Keep the <aside> attributes/classes, only swap children
            asideEl.innerHTML = html;
          }
        }
        // After re-render, refresh the cached drawer/overlay element refs
        drawer  = $('.cart-drawer') || drawer;
        overlay = $('.cart-overlay') || overlay;
      });
  }

  function refreshCartCount() {
    return fetch(CART + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if (cart) updateCartCount(cart.item_count); });
  }

  function changeLine(line, quantity) {
    return fetch(CART + '/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(j){ throw j; });
      return r.json();
    });
  }

  // ---------- Delegated cart-line actions ----------
  document.addEventListener('click', function(e){
    // Re-resolve drawer in case it was re-rendered
    var liveDrawer = $('.cart-drawer');
    var item = e.target.closest('[data-cart-item]');
    if (!item || !liveDrawer || !liveDrawer.contains(item)) return;

    var dec = e.target.closest('[data-cart-dec]');
    var inc = e.target.closest('[data-cart-inc]');
    var rm  = e.target.closest('[data-cart-remove]');
    if (!dec && !inc && !rm) return;

    e.preventDefault();
    var line = parseInt(item.getAttribute('data-cart-line') || '0', 10);
    if (!line) return;

    var qtyEl = item.querySelector('[data-cart-qty]');
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next;
    if (rm) next = 0;
    else if (dec) next = Math.max(0, cur - 1);
    else next = cur + 1;

    withBusy(function(){
      return changeLine(line, next)
        .then(function(cart){ updateCartCount(cart.item_count); })
        .then(rerenderDrawer)
        .catch(function(err){
          console.error('Cart change failed', err);
          // Fallback: hard reload to recover
          window.location.reload();
        });
    });
  });

  // ---------- Add to bag ----------
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-bag]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) {
      // No form — nothing to do
      e.preventDefault();
      openCart();
      return;
    }
    e.preventDefault();
    btn.disabled = true;
    var fd = new FormData(form);
    // Strip the submit-button 'add' field to avoid sending it to the API
    fd.delete('add');
    withBusy(function(){
      return fetch(CART + '/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: fd
      }).then(function(r){
        if (!r.ok) return r.json().then(function(j){ throw j; });
        return r.json();
      }).then(function(){
        return rerenderDrawer();
      }).then(function(){
        return refreshCartCount();
      }).then(function(){
        openCart();
      }).catch(function(err){
        console.error('Add to cart failed', err);
        alert((err && (err.description || err.message)) || 'Unable to add to bag.');
      }).finally(function(){
        btn.disabled = false;
      });
    });
  });

  // On first load: sync the badge count only. Drawer is already rendered
  // server-side with the correct items — do NOT touch its HTML.
  refreshCartCount();

  // ---------- Reveal on scroll ----------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'translateY(0)';
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '-10% 0px' });
    $$('.section, .editorial, .pdp__story').forEach(function(el){
      el.style.opacity = '0';
      el.style.transform = 'translateY(8px)';
      el.style.transition = 'opacity 600ms cubic-bezier(0.22,0.61,0.36,1), transform 600ms cubic-bezier(0.22,0.61,0.36,1)';
      io.observe(el);
    });
  }
})();
